import { useEffect, useState } from "react";
import { Col } from "reactstrap";
import { Bar } from 'react-chartjs-2';
import { checkDatatype, formatcsvTable, roundToNearest } from "../utils/NumberUtils";
import { format } from "date-fns";

const ChartLayout1 = ({ posts, type, isAuto, date }) => {
    const [chart, setChart] = useState({
        max: [50, 1000, 100000],
        step: [10, 100, 10000],
        scale: [(10 * 5), (100 * 5), (10000 * 5)]
    });
    const [label, setLabel] = useState([]);
    const [screenHeight] = useState("30vh");


    const legendMargin = {
        beforeInit(chart) {
            const originalFit = chart.legend.fit;
            chart.legend.fit = function fit() {
                originalFit.bind(chart.legend)();
                this.height += 20;
            }
        }
    }

    useEffect(() => {
        const minLabel = Array.from({ length: 1440 }, (_, i) => {
            const hour = Math.floor(i / 60);
            const minute = i % 60;
            const formattedHour = hour < 10 ? '0' + hour : hour;
            const formattedMinute = minute < 10 ? '0' + minute : minute;
            return `${formattedHour}:${formattedMinute}`; // display hour and minute in the label
        });
        setLabel(minLabel);
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (posts === null) {
            return null;
        };
        const max1 = parseFloat(Math.max(...(checkData(posts.pv_power)))) + 5;
        const max2 = parseFloat(Math.max(...(checkData(posts.consumption_power)))) + 5;
        const max3 = parseFloat(Math.max(...(checkData(posts.mmr_power)))) + 5;
        const max4 = parseFloat(Math.max(...(checkData(posts.bt_power)))) + 5;

        let maxVal = 80000;

        if (isAuto) {

            maxVal = parseFloat(Math.max(max1, max2, max3, max4)) - 5;
            if (type === 'day') {
                maxVal = 2000000
            }
            else if (type === 'week') {
                maxVal = 1500000
            } else if (type === 'month') {
                maxVal = 1500000
            } else {
                maxVal = 40000000
            }

            const stepVal = parseInt(Math.round((maxVal) / 5));
            const step1 = parseInt(Math.round(max1 / 5));
            const step2 = parseInt(Math.round(max2 / 5));

            setChart({
                step: [step1, step2, stepVal],
                scale: [step1 * 5, step2 * 5, stepVal * 5]
            });
        } else {
            maxVal = parseFloat(Math.max(max1, max2, max3, max4)) - 5;
            let final = maxVal > 100000 && maxVal < 1000000 ? roundToNearest(maxVal, 250000) : maxVal > 1000000 && maxVal < 10000000 ? roundToNearest(maxVal, 2500000) : maxVal > 10000000 && maxVal < 100000000 ? roundToNearest(maxVal, 25000000) : maxVal > 100000000 && maxVal < 1000000000 ? roundToNearest(maxVal, 250000000) : roundToNearest(maxVal + 5, 25000)

            const stepVal = parseInt(Math.round((final) / 5));

            const step1 = parseInt(Math.round(max1 / 5));
            const step2 = parseInt(Math.round(max2 / 5));

            setChart({
                step: [step1, step2, stepVal],
                scale: [step1 * 5, step2 * 5, stepVal * 5]
            });
        }//eslint-disable-next-line
    }, [posts]);

    if (posts === null) {
        return null;
    };

    const checkData = (values) => {
        let newValue = [];
        for (let i = 0; i < values.length; i++) {
            if (typeof values[i] === "number") {
                newValue.push(values[i].toFixed(0));

            } else {
                newValue.push(0);
            }
        }
        return newValue;
    }

    return <>
        <Col md={12} className="p-0 graphMaintain" style={{ height: screenHeight }}>
            {/* {type === 'day' ?
                    <span className="scale-text">%</span> : ''
                }
                <span className="scale-text ml-4">Wh</span> */}
            <Bar
                id="top-chart"
                data={{
                    labels: label,
                    datasets: [
                        {
                            type: "line",
                            label: "蓄電池充電率 [%]",
                            fill: false,
                            data: checkData(posts.soc),
                            borderColor: "#964b00",
                            // backgroundColor: "#964b00",
                            yAxisID: 'y1',
                            // pointStyle: 'round',
                            // pointRadius: 3,
                            pointBackgroundColor: "#964b00",
                            order: 1,
                            // stack: 'stack0',
                        },
                        {
                            // barPercentage: 0.9,
                            type: 'line',
                            label: '発電電力 [kW]',
                            data: checkDatatype(posts.pv_power),
                            backgroundColor: "#008000",
                            borderColor: "#008000",
                            order: 2,
                            // stack: 'stack0',



                        },
                        {
                            // barPercentage: 0.9,
                            type: "line",
                            label: "買電力(+)/売電力(-) [kW] ",
                            data: checkDatatype(posts.mmr_power),
                            backgroundColor: "#cc0000",
                            borderColor: "#cc0000",
                            order: 2,
                            // stack: 'stack0',


                        },
                        {
                            // barPercentage: 0.9,
                            type: "line",
                            label: "消費電力 [kW]",
                            data: checkDatatype(posts.consumption_power),
                            backgroundColor: "#a9a9a9",
                            borderColor: "#a9a9a9",
                            // stack: 'stack1',
                            order: 2,
                        },
                        {
                            type: "line",
                            // barPercentage: 0.9,
                            label: "蓄電池放電電力(+)/蓄電池充電電力(-) [kW]",
                            data: checkDatatype(posts.bt_power),
                            backgroundColor: "#0000ff",
                            borderColor: "#0000ff",
                            order: 2,
                            // stack: 'stack0'
                        },
                    ]
                }}
                options={{
                    resposive: true,
                    maintainAspectRatio: false,
                    animation: true,
                    barPercentage: 1,
                    elements: {
                        point: {
                            radius: 0
                        }
                    },
                    interaction: {
                        intersect: false,
                        mode: "index"
                    },

                    plugins: {
                        tooltip: {
                            //enabled: false,
                            backgroundColor: "#000000",
                            //borderColor: 'rgba(0, 255, 255, 1)',
                            borderWidth: 1,
                            title: { display: false },
                            displayColors: true,
                            boxWidth: 5,
                            boxHeight: 25,
                            caretPadding: 20,
                            // xAlign: 'left',
                            yAlign: "center",
                            bodyFont: { size: 13 },
                            // bodyColor: 'black',
                            filter: function (context) {
                                // var label = context.dataset.data[context.dataIndex];
                                // if (label === 0) {
                                //     return false;
                                // } else {
                                return true;
                                // }
                            },
                            callbacks: {
                                title: function (tooltipItems, data) {
                                    //Return value for title
                                    return `${format(new Date(date), 'yyyy/MM/dd')} ${tooltipItems[0].label}`;
                                },
                                label: function (context) {
                                    const label = context.dataset.label.split('[')[0].trim();
                                    if (context.dataset.label.includes("%")) {
                                        return `${label} : ${context.dataset.data[context.dataIndex]}% `
                                    } else {
                                        const value = formatcsvTable(context.dataset.data[context.dataIndex], 2)
                                        return `${label} : ${value} `;
                                    }
                                },

                            }
                        }, legend: {
                            onClick: (click, legendItem, legend) => {
                                const datasets = legend.legendItems.map((dataset, index) => {
                                    return dataset.text;
                                });
                                const index = datasets.indexOf(legendItem.text);
                                if (legend.chart.isDatasetVisible(index) === true) {
                                    legend.chart.hide(index);
                                } else {
                                    legend.chart.show(index);
                                }
                            },
                            labels: {
                                boxWidth: 40,
                                usePointStyle: true,
                                generateLabels: (chart) => {
                                    let visibility = [];
                                    for (let i = 0; i < chart.data.datasets.length; i++) {
                                        if (chart.isDatasetVisible(i) === true) {
                                            visibility.push(false);

                                        } else {
                                            visibility.push(true);
                                        }
                                    }
                                    let pointStyle = [];
                                    chart.data.datasets.forEach(dataset => {
                                        if (dataset.type === 'line') {
                                            pointStyle.push('line')

                                        }
                                        else {
                                            pointStyle.push('rect');
                                        }
                                    });
                                    return chart.data.datasets.map(
                                        (dataset, index) => ({
                                            text: dataset.label,
                                            fillStyle: dataset.backgroundColor,
                                            strokeStyle: dataset.borderColor,
                                            lineWidth: 3,
                                            pointStyle: pointStyle[index],
                                            hidden: visibility[index],

                                        })
                                    )
                                }
                            },

                        },
                    },
                    scales: {
                        y: {
                            // min: 0,
                            max: chart.scale[2],
                            stacked: false,
                            grid: { display: true, borderColor: '#000000' },
                            ticks: {
                                padding: 16,
                                stepSize: chart.step[2],
                                autoSkip: false,
                                // maxTicksLimit: 7,
                                callback: (val, type) => {
                                    if (val === 0) {
                                        return "0";
                                    } else if (val > 999999) {
                                        const newVal = val / 1000000;
                                        return newVal.toFixed(1) + 'M';
                                    }
                                    else {
                                        return Math.round(val / 1000) + 'K';
                                    }
                                },

                                color: "#000000"

                            },
                            display: true,
                            position: 'left'
                        },
                        y1: {
                            // min: 0,
                            max: 100,
                            display: true,
                            position: 'left',
                            stacked: false,
                            grid: { display: false, borderColor: '#000000' },
                            ticks: {
                                stepSize: 20,
                                autoSkip: false,
                                color: "#000000",

                                callback: (val) => {
                                    if (val === 0) {
                                        return "0";
                                    } else {
                                        return val;
                                    }
                                },

                            },
                        },
                        x: {
                            grid: { display: true, borderColor: "#000000" },
                            stacked: true,

                            ticks: {
                                color: "#000000",
                                callback: function (value, index) {
                                    // Show only the labels for every hour (i.e., when the index is a multiple of 60)
                                    if (index % 60 === 0) {
                                        const hour = Math.floor(index / 60);
                                        const formattedHour = hour < 10 ? '0' + hour : hour;
                                        return `${formattedHour}:00`;
                                    } else {
                                        return null;
                                    }
                                },
                            },
                        },
                    },
                    color: "#000000"
                }}
                plugins={[legendMargin, {
                    afterDraw: function (chart, easing) {
                        if (chart.tooltip._active && chart.tooltip._active.length) {
                            const activePoint = chart.tooltip._active[0];
                            const ctx = chart.ctx;
                            const x = activePoint.element.x;
                            const topY = chart.scales.y.top;
                            const bottomY = chart.scales.y.bottom;

                            // Check if activePosition is greater than 12
                            const reposition = 12 * 60;
                            if (activePoint.index > reposition) {
                                chart.tooltip.options.xAlign = 'right'; // Change xAlign to 'left'
                            } else {
                                chart.tooltip.options.xAlign = 'left'; // Reset xAlign to 'center' (default)
                            }

                            // Draw Vertical Line
                            ctx.save();
                            ctx.beginPath();
                            ctx.moveTo(x, topY);
                            ctx.lineTo(x, bottomY);
                            ctx.lineWidth = 2;
                            ctx.strokeStyle = '#000';
                            ctx.stroke();
                            ctx.restore();
                        }
                    }
                }]}
            />
            <span className="scale-text graph1-text ml-2">%</span>
            <span className="scale-text graph1-text ml-5">W</span>
        </Col>
    </>;
};

export default ChartLayout1;